import React, { ComponentProps } from 'react'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import styles from './styles.module.scss'

type FlashBannerItemWrapperProps = {
  link?: string | null
  backgroundColor?: string | null
  contentColor: string
  size: 'regular' | 'large'
} & ComponentProps<'div'> &
  ComponentProps<'a'>

function FlashBannerItemWrapper({
  backgroundColor,
  link,
  children,
  contentColor,
  size = 'regular',
  ...props
}: React.PropsWithChildren<FlashBannerItemWrapperProps>) {
  const isPhabletDown = useMediaQuery({
    maxWidth: BREAKPOINT_SIZES.TABLET - 1
  })

  return link && isPhabletDown ? (
    <a
      href={link}
      className={`${styles.flashItem__link} ${styles[size]} ${styles[contentColor]}`}
      style={{ backgroundColor: backgroundColor || undefined }}
      {...props}
    >
      {children}
    </a>
  ) : (
    <div
      className={`${styles.flashItem} ${styles[size]} ${styles[contentColor]}`}
      style={{ backgroundColor: backgroundColor || undefined }}
      {...props}
    >
      {children}
    </div>
  )
}

export default FlashBannerItemWrapper
